import { createReviewsAPIClient } from './reviewsAPIClient';

export const reviewsAPIClient = createReviewsAPIClient();
